import React, { Fragment, HTMLProps, useEffect } from 'react';
import Icon from '../../icons/Icon';
import { FormicaSelectBoxItem } from './FormicaSearchSelectBox';
import { OverlayPanel } from 'primereact/overlaypanel';
import _ from 'lodash';
import LanguageUtil from '../../util/LanguageUtil';

function FormicaGroupedSearchSelectBox({
  id,
  onChangeValue,
  selectBoxClassName = '',
  options,
  icon,
  rounded,
  disabled,
  disableSelect,
  placeholder,
  value,
  ghost = false,
  customSize = 'medium',
  ...rest
}: FormicaGroupSelectBoxProps) {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [flag, setFlag] = React.useState<boolean>(true);
  const [selectBoxId, setSelectBoxId] = React.useState<string>('');
  const [search, setSearch] = React.useState<string>('');
  const selectBoxRef = React.useRef<HTMLDivElement>(null);
  const menuRef = React.useRef<OverlayPanel>(null);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside); // mount
    return () => document.removeEventListener('click', handleClickOutside); // unmount
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.querySelector('.scrollable-editor-container')?.classList.remove('overflow-y-scroll');
      if (!document.querySelector('.scrollable-editor-container')?.classList.contains('overflow-y-hidden')) {
        document.querySelector('.scrollable-editor-container')?.classList.add('overflow-y-hidden');
      }
    } else {
      if (!document.querySelector('.scrollable-editor-container')?.classList.contains('overflow-y-scroll')) {
        document.querySelector('.scrollable-editor-container')?.classList.add('overflow-y-scroll');
      }
      document.querySelector('.scrollable-editor-container')?.classList.remove('overflow-y-hidden');
    }
  }, [isOpen]);

  const onChangeSelectedItem = (item: FormicaSelectBoxItem) => {
    onChangeValue(_.cloneDeep(item));
    setIsOpen(false);
    setFlag(true);
    selectBoxRef.current?.classList.remove('formica-shadow');
  };

  const onChangeSelectedItemWithGhost = (item: FormicaSelectBoxItem, e: React.MouseEvent<HTMLLIElement>) => {
    onChangeSelectedItem(item);
    menuRef.current?.hide();
  };
  const handleClickOutside = (event: any) => {
    // bu divin dışına tıklanırsa selectbox kapanır.
    if (selectBoxRef.current && !selectBoxRef.current.contains(event.target)) {
      setIsOpen(false);
      setFlag(true);
      setSearch('');
      selectBoxRef.current?.classList.remove('formica-shadow');
    }
  };

  const toggleOverlay = (event: React.MouseEvent<HTMLButtonElement> | any) => {
    menuRef?.current?.toggle(event);
    selectBoxRef.current?.classList.add('formica-shadow');
    setIsOpen(true);
  };

  const onChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  return (
    // en dışarıya focus border atmak istersen bir divle daha sarmala.
    <div
      ref={selectBoxRef}
      className={`flex gap-x-3 ${selectBoxClassName} text-md  ${ghost ? ' px-5 bg-transparent hover:bg-white  border-transparent focus-within:border-f-purple focus-within:bg-white  hover:border-f-purple ' : 'border-f-black-5  focus-within:border-f-purple hover:border-f-purple bg-white '} shadow-black/2  focus-within:formica-shadow min-w-[150px] border-[1px]  w-full items-center justify-center ${getCustomSize(customSize)}  ${rounded ? 'rounded-[4px]' : 'rounded-[2px]'} relative   group`}
    >
      <div
        className={'flex focus-within:border-[10px] w-full h-full px-2 cursor-pointer items-center'}
        data-testid={(rest as any)['data-testid']}
        onClick={(e) => toggleOverlay(e)}
      >
        <div className={`flex h-full items-center justify-center ${icon && 'border-r-[1px] min-w-[42px] w-[42px] '} border-f-black-5`}>
          {icon && <Icon icon={icon ? icon : 'search'} size={18} className={'text-primary group-focus:text-f-purple text-f-primary '} />}
        </div>
        <div className={'flex w-full h-full items-center overflow-x-scroll'}>
          {value && <p className={'text-primary text-xs 2xl:text-md'}>{value}</p>}
          {!value && placeholder && <p className={'text-f-black-4 text-xs 2xl:text-md'}>{placeholder}</p>}
        </div>
        <div id={id} className={'flex cursor-pointer h-full items-center justify-center mr-2'}>
          <Icon icon={'arrow-down'} size={16} className={'text-f-black-3 group-focus:text-f-purple'} />
        </div>
      </div>
      {ghost && (
        <OverlayPanel
          ref={menuRef}
          style={{ zIndex: 1003 }}
          onHide={() => setIsOpen(false)}
          className={`${!disableSelect ? 'visible' : 'hidden'} flex flex-col bg-white w-[250px]  max-h-[200px] overflow-scroll border-[1px] left-0`}
        >
          <div className={'flex items-center h-12 shrink-0 justify-start px-2 py-2'}>
            <span className={''}>
              <Icon icon={'search'} size={20} />
            </span>
            <input
              className={'flex rounded-[4px]  items-center w-full h-full border-none focus:outline-none indent-2 text-f-black-3 text-md'}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.search', defaultMessage: 'Search' })}
              value={search}
              onChange={(e) => onChangeSearch(e)}
            />
          </div>
          <ul className={'flex flex-col w-full'}>
            {flag && options && options.length > 0
              ? options.map((option, index) => {
                  return (
                    <Fragment key={index}>
                      <li
                        key={index}
                        className={`flex text-sm border-b text-primary hover:cursor-default font-semibold h-[40px] min-h-[40px] items-center justify-start gap-x-2 px-3 py-2`}
                      >
                        <h5>{option.groupName}</h5>
                      </li>
                      <ul>
                        {option.items
                          .filter((item) => {
                            if (item.label.trim() == '') return item;
                            return item.label.toLowerCase().includes(search.toLowerCase()) || item.value.toLowerCase().includes(search.toLowerCase());
                          })
                          .map((item, childIndex) => {
                            return (
                              <li
                                key={childIndex}
                                onClick={(e) => onChangeSelectedItemWithGhost(item, e)}
                                className={`flex cursor-pointer text-sm text-f-black-2 h-[34px] min-h-[34px] items-center hover:text-f-purple justify-start gap-x-2 px-6 py-2 hover:bg-[#F7F8FA]`}
                                data-testid={`select-item-${option.groupName}-${item.value}`}
                              >
                                {item.label}{' '}
                              </li>
                            );
                          })}
                      </ul>
                    </Fragment>
                  );
                })
              : null}
          </ul>
        </OverlayPanel>
      )}
      {!ghost && (
        <div
          style={{ zIndex: 1003 }}
          className={`${isOpen && !disableSelect ? 'visible' : 'hidden'} flex flex-col bg-white w-full  max-h-[200px] overflow-scroll absolute ${getPositionBySize(customSize)}  border-[1px] left-0`}
        >
          <div className={'flex items-center h-12 shrink-0 border-b justify-start'}>
            <input
              className={'flex items-center w-full h-full border-none focus:outline-none indent-2 text-f-black-3'}
              placeholder={LanguageUtil.get({ id: 'common.input.placeholder.search', defaultMessage: 'Search' })}
              value={search}
              onChange={(e) => onChangeSearch(e)}
            />
          </div>
          <ul className={'flex flex-col w-full'}>
            {flag && options && options.length > 0
              ? options.map((option, index) => {
                  return (
                    <Fragment key={index}>
                      <li
                        key={index}
                        className={`flex text-sm border-b text-primary hover:cursor-default font-semibold h-[40px] min-h-[40px] items-center justify-start gap-x-2 px-3 py-2`}
                      >
                        <h5>{option.groupName}</h5>
                      </li>
                      <ul>
                        {option.items
                          .filter((item) => {
                            if (item.label.trim() == '') return item;
                            return item.label.toLowerCase().includes(search.toLowerCase()) || item.value.toLowerCase().includes(search.toLowerCase());
                          })
                          .map((item, childIndex) => {
                            return (
                              <li
                                key={childIndex}
                                onClick={() => onChangeSelectedItem(item)}
                                data-testid={`select-item-${option.groupName}-${item.value}`}
                                className={`flex text-sm text-f-black-2 h-[34px] min-h-[34px] items-center hover:text-f-purple justify-start gap-x-2 px-6 py-2 hover:bg-[#F7F8FA]`}
                              >
                                {' '}
                                {item.label}{' '}
                              </li>
                            );
                          })}
                      </ul>
                    </Fragment>
                  );
                })
              : null}
          </ul>
        </div>
      )}
    </div>
  );
}

const getCustomSize = (customSize: 'small' | 'medium' | 'large') => {
  switch (customSize) {
    case 'small':
      return 'h-[32px] min-h-[32px]';
    case 'medium':
      return 'h-[34px] min-h-[34px]';
    case 'large':
      return 'h-[40px] min-h-[40px]';
    default:
      return 'h-[34px] min-h-[34px]';
  }
};
const getPositionBySize = (customSize: 'small' | 'medium' | 'large') => {
  switch (customSize) {
    case 'small':
      return 'top-[31px]';
    case 'medium':
      return 'top-[33px]';
    case 'large':
      return 'top-[39px]';
    default:
      return 'top-[39px]';
  }
};

export interface FormicaGroupSelectBoxProps extends Omit<HTMLProps<HTMLInputElement>, 'onChange'> {
  id?: string;
  options: FormicaGroupSelectBoxItem[];
  icon?: string;
  selectBoxClassName?: string;
  onChangeValue: (value: FormicaSelectBoxItem) => void;
  rounded?: boolean;
  disableSelect?: boolean;
  customSize?: 'small' | 'medium' | 'large';
  ghost?: boolean;
}

export interface FormicaGroupSelectBoxItem {
  groupName: string;
  items: FormicaSelectBoxItem[];
}

export default FormicaGroupedSearchSelectBox;
